import { Controller } from "@hotwired/stimulus"

// Accordion controller for expanding/collapsing child rows in a table.
//
// Toggles `hidden` on all <tr> elements whose `data-parent-quest-id`
// matches the clicked chevron's `data-quest-id`. Works for both
// sub-quests under a parent quest and tasks under a sub-quest.
//
// Usage (on <tbody>):
//   <tbody data-controller="quest-accordion">
//     <tr>
//       <td>
//         <button data-action="click->quest-accordion#toggle"
//                 data-quest-id="1">▶</button>
//         Quest Title
//       </td>
//     </tr>
//     <tr data-parent-quest-id="1" class="hidden">
//       Sub-quest or task row
//     </tr>
//   </tbody>
//
export default class extends Controller {
  toggle(event) {
    event.stopPropagation()
    const button = event.currentTarget
    const questId = button.dataset.questId
    const childRows = this.element.querySelectorAll(`tr[data-parent-quest-id="${questId}"]`)

    if (childRows.length === 0) return

    const isExpanding = childRows[0].classList.contains("hidden")

    childRows.forEach(row => {
      if (isExpanding) {
        row.classList.remove("hidden")
      } else {
        row.classList.add("hidden")
        // When collapsing a parent, also collapse any nested children (sub-accordion)
        const nestedId = row.dataset.questId
        if (nestedId) {
          this.collapseChildren(nestedId)
        }
      }
    })

    // Rotate chevron
    const chevron = button.querySelector("[data-chevron]")
    if (chevron) {
      chevron.classList.toggle("rotate-90", isExpanding)
    }
  }

  collapseChildren(parentId) {
    const nested = this.element.querySelectorAll(`tr[data-parent-quest-id="${parentId}"]`)
    nested.forEach(row => row.classList.add("hidden"))

    // Reset any nested chevrons
    const chevronBtn = this.element.querySelector(`button[data-quest-id="${parentId}"]`)
    if (chevronBtn) {
      const chevron = chevronBtn.querySelector("[data-chevron]")
      if (chevron) chevron.classList.remove("rotate-90")
    }
  }
}
